import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ index, overline, title, subtitle, testId }) => (
  <div className="mb-14 lg:mb-20" data-testid={testId}>
    <Reveal>
      <div className="flex items-center gap-4 mb-6">
        <span className="font-mono-tech text-xs text-[#64748B]">{index}</span>
        <span className="h-px w-12 bg-[#E06D28]/60" />
        <span className="overline-label">{overline}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F4F6F8] max-w-2xl leading-tight">
        {title}
      </h2>
    </Reveal>
    {subtitle && (
      <Reveal delay={0.16}>
        <p className="mt-5 text-base text-[#94A3B8] max-w-xl leading-relaxed">{subtitle}</p>
      </Reveal>
    )}
  </div>
);
